var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.615 9.6a1.2 1.2 0 1 0-2.4 0zm-16.8 0a1.2 1.2 0 1 0-2.4 0zm17.151 3.248a1.2 1.2 0 0 0 1.697-1.697zM12.015 1.2l.848-.849a1.2 1.2 0 0 0-1.697 0zM.366 11.152a1.2 1.2 0 1 0 1.697 1.696zM6.015 24h12v-2.4h-12zm15.6-3.6V9.6h-2.4v10.8zm-16.8 0V9.6h-2.4v10.8zm18.848-9.248-10.8-10.8-1.697 1.696 10.8 10.8zM11.166.351l-10.8 10.8 1.697 1.696 10.8-10.8zM18.015 24a3.6 3.6 0 0 0 3.6-3.6h-2.4a1.2 1.2 0 0 1-1.2 1.2zm-12-2.4a1.2 1.2 0 0 1-1.2-1.2h-2.4a3.6 3.6 0 0 0 3.6 3.6z"
  })));
};
export default SvgHome;